module.exports = __webpack_public_path__ + "manager/img/icon-empty.7764e30.png";